import React from 'react'

import Image from '../../atoms/Image'
import Paragraph from '../../atoms/Paragraph'

interface Props {
  content?: any
  image?: any
  position?: 'None' | 'Image on the left' | 'Image on the right'
  stackedLayOut: boolean
}

const Contents = ({ content, image, position, stackedLayOut }: Props) => {
  if (image && position && position !== 'None' && stackedLayOut) {
    const img = image.fields?.image?.fields?.file
    const width = img?.details?.image?.width
    const height = img?.details?.image?.height
    const landscape = width > height
    const accordianImageSize = landscape ? 'lg:w-[50%]' : 'lg:w-[30%] max-h-[400px] lg:max-h-none'
    const isLeft = position === 'Image on the left'

    return (
      <div className={`${!isLeft ? 'flex-row-reverse' : ''} items-start gap-10 p-32 pt-0 lg:flex`}>
        <Image
          className={`${accordianImageSize} flex-none mb-5 lg:mb-0`}
          imageUrl={img?.url}
          altText={img?.title}
        />
        <Paragraph content={content} classes="flex-1" />
      </div>
    )
  }

  return (
    <div className={`p-32 pt-0`}>
      <Paragraph content={content} />
    </div>
  )
}

export default Contents
